import React from "react";
import { Typography } from "@shared/ui.primitives";
import { Link } from "components/Link";
import * as styles from "./CList.css";

export type CListType = {
  title: string;
  description: string;
  link: {
    href: string;
    text: string;
  };
  disclaimer: {
    title: string;
    text: string;
  };
};

type Props = {
  cList: CListType;
};

export const CList: React.FC<Props> = ({ cList }) => {
  return (
    <>
      <Typography as="h6" variant="subheader-6" color="primary-dark">
        {cList.title}
      </Typography>
      <Typography>{cList.description}</Typography>
      <div className={styles.spaceAround}>
        <Typography>
          Learn more about{" "}
          <Link
            variant="acuminLight"
            textDecoration="underline"
            href={cList.link.href}
          >
            {cList.link.text}
          </Link>{" "}
        </Typography>
      </div>
      <div className={styles.spaceAround}>
        <Typography as="h6" variant="subheader-6" color="primary-dark">
          {cList.disclaimer.title}
        </Typography>
      </div>
      <Typography>{cList.disclaimer.text}</Typography>
    </>
  );
};
